export const StatisticsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66669 2.16602C2.66669 1.88987 2.44283 1.66602 2.16669 1.66602C1.89054 1.66602 1.66669 1.88987 1.66669 2.16602V15.5107C1.66669 17.1675 3.00983 18.5107 4.66669 18.5107H18.0114C18.2875 18.5107 18.5114 18.2868 18.5114 18.0107C18.5114 17.7345 18.2875 17.5107 18.0114 17.5107H15.1159V9.78992C15.1159 9.05354 14.519 8.45658 13.7826 8.45658H12.054C11.3176 8.45658 10.7206 9.05354 10.7206 9.78992V17.5107H9.45716V4.13112C9.45716 3.39474 8.8602 2.79779 8.12382 2.79779H6.3952C5.65882 2.79779 5.06187 3.39474 5.06187 4.13112V17.5107H4.66669C3.56212 17.5107 2.66669 16.6153 2.66669 15.5107V2.16602ZM6.06187 17.5107H8.45716V4.13112C8.45716 3.94702 8.30792 3.79779 8.12382 3.79779H6.3952C6.21111 3.79779 6.06187 3.94702 6.06187 4.13112V17.5107ZM11.7206 17.5107H14.1159V9.78992C14.1159 9.60582 13.9667 9.45658 13.7826 9.45658H12.054C11.8699 9.45658 11.7206 9.60582 11.7206 9.78992V17.5107Z"
        fill="currentColor"
      />
    </svg>
  );
};
